import Company from "./Company/Company";
import Print from "./Print";
export default { Company, Print };
